import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Mostrar o ocultar el tour
 * @param token
 * @param http HttpClient instance
 * @returns Observable<any>
 */
export function toggleTourApi(
  token: string | undefined,
  http: HttpClient
): Observable<any> {
  const url = `${environment.URL_API}/account/tour`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.patch<any>(url, { headers });
}

/**
 * Obtener las notificaciones
 * @param http HttpClient instance
 * @param token Authorization token
 * @param queryParams Query parameters for filtering or pagination
 * @returns Observable<any>
 */
export function getNotificationsApi(
  http: HttpClient,
  token: string | undefined,
  queryParams: any = {}
): Observable<any> {
  const params = new URLSearchParams(queryParams).toString();
  const baseUrl = `${environment.URL_API}/notifications`;
  const url = params ? `${baseUrl}?${params}` : baseUrl;
  const headers = { Authorization: `Bearer ${token}` };
  return http.get<any>(url, { headers });
}

/**
 * Marcar como leída una notificación
 * @param http HttpClient instance
 * @param token Authorization token
 * @param id Notification ID
 * @returns Observable<any>
 */
export function markAsReadApi(
  http: HttpClient,
  token: string | undefined,
  id: number
): Observable<any> {
  const url = `${environment.URL_API}/notifications/${id}/read`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.put<any>(url, { headers });
}

/**
 * Marcar todas las notificaciones como leídas
 * @param http HttpClient instance
 * @param token Authorization token
 * @returns Observable<any>
 */
export function markAllAsReadApi(
  http: HttpClient,
  token: string | undefined
): Observable<any> {
  const url = `${environment.URL_API}/notifications/read`;
  const headers = { Authorization: `Bearer ${token}` };
  return http.put<any>(url, {}, { headers });
}
